module.exports = __webpack_public_path__ + "img/pic1.002aad10.png";